module.exports = __webpack_public_path__ + "img/3.f69ae6c5.png";